import request from "../utils/request";
import { hostUrl } from "../utils/constant"

// 软件列表：国内域显式传 is_international=0，与 intl lists 隔离
export const getSoftList = function(params) {
  return request.post(`main/plat/v1/softmgr/lists`, {
    ...params,
    is_international: 0,
  });
};

// 配置列表
export const getconfiglist = function() {
  return request.get(`main/plat/v1/common/getconfiglist`);
};

// 创建软件：国内域显式传 is_international=0
export const createSoft = function(params) {
  return request.post(`main/plat/v1/softmgr/create`, {
    ...params,
    is_international: 0,
  });
};

//  

